import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { withAuthLayout } from '../../components/hocs/withAuthLayout';

import './styles.scss';

const Info = () => {
	const params = useParams();
	
	useEffect(() => {
		if(params.id === 'success') {
			localStorage.clear();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]);

	const messages = {
		success: 'Thanks for signing up, you will not be able to log in until the administrator has approved of your facility.',
		approved: 'Thanks for your email verification',
		hcapproved: 'Thanks for email verification',
		rejectEmail: 'Email changes rejected, original email for login remains the same'
	}
	return (
		<div className="info">
			<div>
				{
					messages[params.id] ? (
						<p className="info__text">{messages[params.id]}</p>
					) : (<p className="info__text">Please use mobile app for Individual or Business login</p>)
				}
			</div>
			<Link to="/login">
				<span>Back to login</span>
			</Link>
		</div>
	);
};

export default withAuthLayout(Info);
